export const getRedirectUri = (path: string): string => {
  if (!!path) {
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }

    return window.location.origin + path;
  }

  return window.location.origin;
};
